<template>
  <div
    v-if="options.length"
    class="applications-filter"
  >
    <div class="applications-filter__title-wrapper">
      <button
        v-if="collapsible"
        class="applications-filter__title-button"
        @click="toggleFilters"
      >
        <h3 class="applications-filter__title">
          {{ title }}
        </h3>
        <span
          class="fas applications-filter____title-button"
          :class="{'fa-chevron-down': !showFilters, 'fa-chevron-up': showFilters}"
        ></span>
      </button>
      <h3
        v-if="!collapsible"
        class="applications-filter__title"
      >
        {{ title }}
        <font-awesome-icon
          v-if="loading"
          class="fas fa-spinner applications-filter__loading-spinner"
          icon="spinner"
        />
      </h3>
    </div>
    <div
      v-show="showFilters"
      class="applications-filter__wrapper"
    >
      <button
        v-for="(item, index) in options"
        :key="item.id"
        class="applications-filter__button"
        :class="{
          'applications-filter__button--active': item.active,
          'applications-filter__button--disabled': item.count === 0 && !item.active
        }"
        :disabled="loading || (item.count === 0 && !item.active)"
        @click="toggleFilterActive(index)"
      >
        {{ item.label }}
      </button>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  components: {
    FontAwesomeIcon
  },
  name: 'ApplicationsFilter',
  props: {
    title: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    collapsible: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['toggle-filter-active'],
  data() {
    return {
      showFilters: false,
    };
  },
  mounted() {
    this.showFilters = !this.collapsible;
  },
  methods: {
    toggleFilters() {
      this.showFilters = !this.showFilters;
    },
    toggleFilterActive(index) {
      this.$emit('toggle-filter-active', index);
    },
  },
};
</script>

<style scoped lang="scss">
  .applications-filter {
    width: 100%;

    &__title-wrapper {
      width: 100%;
      padding-bottom: gap-size(calc(1/2));
      margin-bottom: gap-size(calc(1/2));
      border-bottom: $border-width solid $color-light-grey;
    }

    &__title-button {
      @include reset-button;

      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      font-size: $font-size-standard;
      color: $color-dark-grey;
    }

    &__title {
      font-family: $font-family;
      font-size: $font-size-xsmall;
      line-height: 1;
      letter-spacing: 0.013rem;
      text-transform: uppercase;
      color: $color-dark-grey;
    }

    &__loading-spinner {
      animation: spin-animation 1s infinite;
      display: inline-block;

      @include education-breakpoint-tablet-down() {
        display: none;
      }
    }

    &__wrapper {
      margin-bottom: gap-size(calc(3/4));
    }

    &__button {
      @include reset-button;

      height: 1.61rem;
      padding: 0 gap-size(calc(1/4));
      background-color: $color-white;
      font-size: $font-size-xxsmall;
      font-weight: $font-weight-medium;
      line-height: 1;
      color: $color-blue;
      border: $border-width solid $color-blue;
      border-radius: $border-radius;
      margin-bottom: gap-size(calc(1/4));
      cursor: pointer;

      @include hover-focus-active {
        background-color: $color-blue;
        border-color: $color-blue;
        color: $color-white;
      }

      &:not(:last-child) {
        margin-right: gap-size(calc(1/4));
      }

      &--active {
        color: $color-white;
        background-color: $color-blue;

        @include hover-focus-active {
          background-color: $color-blue-button-dark;
          border-color: $color-blue-button-dark;
        }
      }

      &--disabled {
        border: $border-width solid $color-disabled-border;
        color: $color-disabled-border;
        background-color: $color-disabled-background;
        cursor: auto;

        @include hover-focus-active {
          background-color: $color-disabled-background;
          border-color: $color-disabled-border;
          color: $color-disabled-border;
        }
      }
    }
  }

  @keyframes spin-animation {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(359deg);
    }
  }
</style>
